import React from "react";
import NetworkError from "components/NetworkError/NetworkError";
import styles from "./KioskLayout.module.css";
import Header from "./Header";

const KioskLayout = ({left, right, error, loading, goBack = null }) => (
  <>
    <Header goBack={goBack} loading={loading} />
    {error && <NetworkError />}
    <div className={styles.KioskLayout}>
      <div className={styles.MapSection}>{left}</div>
      <div className={styles.MenuSection}>{right}</div>
    </div>
  </>
);

export default KioskLayout;
